const StepHelperMixin = {
  methods: {
    setStepIsValid (bool) {
      // note all component must have a name!
      this.$emit('step-validation', { name: this.$options.name, value: !!bool })
    }
  },
  mounted () {
    this.$parent.$on('validate-step', this.validateStep())
  }
}

export default StepHelperMixin
